import { createAction, createReducer } from '@reduxjs/toolkit';

import { IPromoData, IPromoState } from './promo.types';

const initialState: IPromoState = {
    queue: [],
    currentPromo: null,
};

export const initPromoController = createAction('promo/initPromoController');
export const addPromoToShowQueue = createAction<IPromoData>('promo/addPromoToShowQueue');
export const showPromo = createAction<IPromoData>('promo/showPromo');
export const hidePromo = createAction('promo/hidePromo');

export const promoReducer = createReducer(initialState, {
    [addPromoToShowQueue.type]: (state, action) => {
        return {
            ...state,
            queue: [...state.queue, action.payload],
        };
    },
    [showPromo.type]: (state, action) => {
        return {
            ...state,
            currentPromo: action.payload,
            queue: state.queue.filter((item) => item.type !== action.payload?.type),
            lastPromoShownTimestamp: new Date(),
        };
    },
    [hidePromo.type]: (state) => {
        return {
            ...state,
            currentPromo: null,
        };
    },
});
